// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account__section___XYsFD {
}

.account__formItemHalf___SroR_ {
  width: 100%;
  padding: 0 10px;
  margin-bottom: 7px;
  box-sizing: border-box;
  display: inline-block;
}

.account__formItemHalf___SroR_ {
}

.account__formItemQuarter___tw4fL {
  width: 25%;
  padding: 0 10px;
  margin-bottom: 15px;
  box-sizing: border-box;
  display: inline-block;
}

.account__formItemQuarter___tw4fL {
}

.account__stateZipContainer___jBQwU {
  display: flex;
  width: 75%;
  margin-bottom: 5px;
}

.account__cityField___NSFeE {
  width: 45%;
  padding-left: 10px;
}

.account__stateField___okEno {
  width: 20%;
  padding-left: 5px;
}

.account__zipField___d2ziJ {
  width: 20%;
  padding-left: 10px;
  margin-bottom: 10px;
}

.account__row___rcu1E {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.account__noteContainer___SEVsZ {
  margin-bottom: 10px;
  padding: 12px 15px;
}

.account__noteText___VRJ1h {
  font-size: 13px;
  color: #777;
  line-height: 1.4;
  margin: 0;
}

.account__noteText___VRJ1h strong {
  display: block;
  margin-bottom: 3px;
  font-weight: 500;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./universal/components/References/account.css"],"names":[],"mappings":"AAGA;AAEA;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;AAEA;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGrayLight, gtCardHeaderBG, borderColor, borderColorLight, gtGray, gtRed, gtBlueDark, gtGreen, gtGreenLight, gtYellowDark, gtYellow, gtYellowLight, text, textLight from colors;\n.section {\n  composes: section from helpers;\n}\n\n.formItemHalf {\n  width: 100%;\n  padding: 0 10px;\n  margin-bottom: 7px;\n  box-sizing: border-box;\n  display: inline-block;\n}\n\n.formItemHalf {\n  composes: formItemHalf clearfix from helpers;\n}\n\n.formItemQuarter {\n  width: 25%;\n  padding: 0 10px;\n  margin-bottom: 15px;\n  box-sizing: border-box;\n  display: inline-block;\n}\n\n.formItemQuarter {\n  composes: formItemQuarter clearfix from helpers;\n}\n\n.stateZipContainer {\n  display: flex;\n  width: 75%;\n  margin-bottom: 5px;\n}\n\n.cityField {\n  width: 45%;\n  padding-left: 10px;\n}\n\n.stateField {\n  width: 20%;\n  padding-left: 5px;\n}\n\n.zipField {\n  width: 20%;\n  padding-left: 10px;\n  margin-bottom: 10px;\n}\n\n.row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.noteContainer {\n  margin-bottom: 10px;\n  padding: 12px 15px;\n}\n\n.noteText {\n  font-size: 13px;\n  color: #777;\n  line-height: 1.4;\n  margin: 0;\n}\n\n.noteText strong {\n  display: block;\n  margin-bottom: 3px;\n  font-weight: 500;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"borderColorLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGreenLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"section": `account__section___XYsFD ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"formItemHalf": `account__formItemHalf___SroR_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemHalf"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"formItemQuarter": `account__formItemQuarter___tw4fL ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemQuarter"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["clearfix"]}`,
	"stateZipContainer": `account__stateZipContainer___jBQwU`,
	"cityField": `account__cityField___NSFeE`,
	"stateField": `account__stateField___okEno`,
	"zipField": `account__zipField___d2ziJ`,
	"row": `account__row___rcu1E`,
	"noteContainer": `account__noteContainer___SEVsZ`,
	"noteText": `account__noteText___VRJ1h`
};
export default ___CSS_LOADER_EXPORT___;
